
import React, { } from 'react';
import { Navigate, useLocation } from "react-router-dom";

import { get } from "lodash";
import { useSelector } from "react-redux"

const Private = ({ children }) => {
    const loginState = useSelector((state) => state.auth.login)
    const isLogged = get(loginState, "isLogged");

    return (
        <>
            {isLogged ? children : <Navigate to="/login" />}
        </>
    );

}

export default Private